import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { finalize } from "rxjs/operators";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormItemAnswerResponse, PatientClient } from "../../../api";

export class FormViewerDialogData {
    itemId: number;
    formId: number;
    timestamp?: number;
    patientName?: string;
    patientId?: string;
}

@Component({
    selector: "smart-form-viewer",
    templateUrl: "./smart-form-viewer.component.html",
    styleUrls: ["./smart-form-viewer.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class SmartFormViewerComponent implements OnInit {
    result: FormItemAnswerResponse;

    horizontalEvolution: boolean;

    patientName: string;

    patientId: string;

    constructor(
        private _progressBarService: FuseProgressBarService,
        public dialogRef: MatDialogRef<SmartFormViewerComponent>,
        @Inject(MAT_DIALOG_DATA) public _data: any,
        private _api: PatientClient
    ) {
        this.dialogRef.addPanelClass("smart-form-viewer-dialog");

        this.patientName = this._data?.patientName;
        this.patientId = this._data?.patientId;
    }

    ngOnInit(): void {
        this._progressBarService.show();

        let itemId = this._data.itemId;
        let formId = this._data.formId;
        let timestamp = this._data.timestamp;

        this._api
            .getFormAnswer(itemId, formId, timestamp)
            .pipe(
                finalize(() => {
                    this._progressBarService.hide();
                })
            )
            .subscribe((result: FormItemAnswerResponse) => {
                this.horizontalEvolution = result.horizontalEvolution;
                this.result = result;
            });
    }
}
